'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('oddCampaignRespondentModule')
    .factory('oddCampaignRespondentService', ['$http', '$q', function ($http) {
        var baseUrl = environment.apiUrl + '/Pilot/api/SurveyV2/BusinessUnit';

        return {
            getCampaignRespondents: function (businessUnitId, campaignId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Campaign/' + campaignId + '/CR/List';

                return $http
                    .get(reqUrl)
                    .then(function (response) { return response.data; })
            },

            addCampaignRespondent: function (businessUnitId, campaignId, employee) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Campaign/' + campaignId + '/CR';

                return $http
                    .post(reqUrl, {campaignRespondent: employee})
                    .then(function (response) { return response.data; })
            },

            removeCampaignRespondent: function (businessUnitId, campaignId, oddCampaignRespondentId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Campaign/' + campaignId + '/CR/' + oddCampaignRespondentId;

                return $http
                    .delete(reqUrl)
                    .then(function (response) {return response.data;})
            },

            addRespondentWithSubordinates: function (businessUnitId, campaignId, employee) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Campaign/' + campaignId + '/CR/WithSubordinates';

                return $http
                    .post(reqUrl, {campaignRespondent: employee})
                    .then(function (response) { return response.data; })
            },

            inviteRespondents: function (businessUnitId, campaignId, respondents) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Campaign/' + campaignId + '/CR/SendInvites';

                return $http
                    .post(reqUrl, {respondents: respondents})
                    .then(function (response) { return response.data; })
            }
        };
    }]);
